import { Firm } from "../types/firm";
import { createApiStore, GenericStore } from "./genericStore";
import api from "../service/api";

interface ClearFirmDataOptions {
  clearTransactions?: boolean;
  clearStocks?: boolean;
  clearAccounts?: boolean;
}

interface FirmStore extends GenericStore<Firm> {
  clearFirmData: (firmId: number, options: ClearFirmDataOptions) => Promise<{ success: boolean; message?: string }>;
}

export const useFirmStore = createApiStore<Firm>("/firm") as unknown as () => FirmStore;

const useFirmStoreBase = useFirmStore as any;

useFirmStoreBase.setState((state: any) => ({
  ...state,
  clearFirmData: async (firmId: number, options: ClearFirmDataOptions) => {
    try {
      useFirmStoreBase.setState({ loading: true });
      const response = await api.post(`/firm/admin/${firmId}/clear-data`, options);
      useFirmStoreBase.setState({ loading: false });
      return { success: true, message: response.data?.message || "Firma verileri başarıyla temizlendi." };
    } catch (error: any) {
      useFirmStoreBase.setState({ loading: false });
      return { success: false, message: error.response?.data?.message || "Veri temizleme sırasında bir hata oluştu." };
    }
  }
}));
